import { applySnapshot, flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { ShareHolderModel } from "../org/OrganizeModel";
import { PaginationModel } from "../share/PagingModel";
import {
  FiveYearPlanHeaderModel,
  IFiveYearPlanHeaderModel,
} from "./FiveYearPlanModel";
import fiveYearPlanAPI from "./FiveYearPlanService";

export const FiveYearPlanListModel = types
  .model("FiveYearPlanListModel", {
    planStatus: customtypes.optional(types.string, ""),
    planRelease: customtypes.optional(types.string, ""),
    year: types.maybe(types.number),
    list: customtypes.optional(types.array(FiveYearPlanHeaderModel), []),
    paging: customtypes.optional(PaginationModel, {
      pageSize: 25,
    }),
    organization: types.optional(ShareHolderModel, {}), //  ShareHolderModel เพราะต้องใช้กับ OrganizationDropdown
    error: customtypes.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    get options() {
      return self.list.map((item: IFiveYearPlanHeaderModel) => {
        return {
          key: item.planID,
          text: item.description,
          value: item.planID,
        };
      });
    },
  }))
  .actions((self: any) => ({
    getFiveYearPlanList: flow(function*() {
      try {
        self.loading = true;
        const result = yield fiveYearPlanAPI.getFiveYearPlansList({
          organizationID: self.organization.shareHolderID,
          planStatus: self.planStatus,
          planRelease: self.planRelease,
          year: self.year || null,
          paging: self.paging,
        });
        self.list = result.data;
        self.setPagination(result);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    removeFiveYearPlan: flow(function*(planID: number) {
      try {
        self.loading = true;
        const result = yield fiveYearPlanAPI.removeFiveYearPlan(planID);
        // console.log("removeFiveYearPlan", result);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    onSelectedFilter: (value: any) => {
      self.setDefaultPagination();
      self.planStatus = value;
      self.getFiveYearPlanList();
    },
    setPagination: (result: any) => {
      self.paging.pageSize = result.pageSize;
      self.paging.pageNo = result.pageNo;
      self.paging.totalRow = result.totalRow;
    },
    onSelectedPage: (pageNo: number) => {
      self.paging.pageNo = pageNo;
      self.getFiveYearPlanList();
    },
    onSearchTextFilter: (value: any) => {
      self.setDefaultPagination();
      self.paging.searchText = value;
      self.getFiveYearPlanList();
    },
    setDefaultPagination: () => {
      self.paging.pageNo = 1;
    },
    onClearFilter: () => {
      self.organization = {};
      self.planStatus = "";
      self.planRelease = "";
      self.list = [];
    },
    resetAll: () => {
      applySnapshot(self, {});
    },
  }));

export type IFiveYearPlanListModel = typeof FiveYearPlanListModel.Type;
